import React from 'react'
import TagTypes from '../TagTypes'
import { ContentWrapper } from '../index'

export default () => (
  <ContentWrapper>
    <TagTypes />
  </ContentWrapper>
)
